import React from 'react';
import { exportEventName } from '.';
import { safeMutate } from '../../../../utils/GeneralUtils';
import PieChart from '../../Reports/templates/PieChart';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getChartConfig, { chartOnlyMetrics } from './utils';
import { isPresent } from '../../../../utils/CoreExtensions/ArrayExtensions';
import useChartReflow from '../../../../hooks/generic/charts/useChartReflow';


const Body = (props) => {
  const { metrics, name } = props;
  const numericMetrics = metrics.filter(metric => !chartOnlyMetrics.includes(metric.uId));
  const isSplitWidget = isPresent(numericMetrics);
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();
  const childClass = `col-12 col-md-6 ${!isSplitWidget && "mx-auto"} dynamic-grid-item-child`;
  const propsForNumericMetrics = safeMutate(props, draftProps => {
    draftProps.metrics = numericMetrics;
  });

  return (
    <div className="custom-max-height-550-px p-3">
      <div className='row no-gutters' ref={ chartWrapperReference }>
        <div className={ `cui-widget-pie-chart ${childClass}` }>
        <PieChart
            chartOptions={ getChartConfig({ metrics, name }) }
            configs={ { export: true, exportEventName } }
            callbackFn={ chartCallbackFunction }
          />
        </div>
        { isSplitWidget &&
          <div className={childClass}>
            <WidgetBodyWrapper { ...propsForNumericMetrics } wrapperPadding="py-3" />
          </div>
        }
      </div>
    </div>
  );
};

export default Body;
